<template>
<!-- 导入运单预览  已弃用 -->
  <div class="pagesBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="saveBtns"
        >确认签收</el-button
      >
    </div>

    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        :span-method="objectSpanMethod"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          >
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableHeigth: "auto",
      myTableHeard: [
        {
          name: "运单号",
          field: "aaa",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "字段AAA",
          field: "bbb",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "字段AAA",
          field: "ccc",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "字段AAA",
          field: "ddd",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "字段AAA",
          field: "eee",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      tableData: [
        {
          aaa: "YD123456788",
          bbb: "对光反射",
          ccc: "aadfasg",
          ddd: "123343",
          eee: "324",
        },
        {
          aaa: "YD123456788",
          bbb: "对光反射",
          ccc: "aadfasg",
          ddd: "123343",
          eee: "324",
        },
        {
          aaa: "YD12345678911",
          bbb: "对光反射",
          ccc: "aadfasg",
          ddd: "123343",
          eee: "324",
        },
        {
          aaa: "YD12345678910",
          bbb: "对光反射",
          ccc: "aadfasg",
          ddd: "123343",
          eee: "324",
        },
        {
          aaa: "YD12345678910",
          bbb: "对光反射",
          ccc: "aadfasg",
          ddd: "123343",
          eee: "324",
        },
      ],
      totalArr: [],
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      this.tableHeigth = windonHeight - 150 + "px";
      console.log("tableHeigth", this.tableHeigth);
    });
  },
  activated() {},
  destroyed() {},
  methods: {
    saveBtns() {},

    // 合并行或者列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 合并行
      if (columnIndex === 2) {
        console.log("row", row);
        console.log("column", column);
        console.log("rowIndex", rowIndex);
        console.log("columnIndex", columnIndex);
      }
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },
  },
};
</script>
<style scoped lang='less'>
.topBtns {
  width: calc(100% - 270px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
</style>